import { Component, Inject, Input, OnInit } from '@angular/core';
import { HelpText, HelpTextBody, HelpTextFooter, HelpTextHeader } from '../model/helpText.model';
import { HelpTextService } from '../service/help-text.service';
import { FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UserProfileService } from 'src/app/component/user-profile/service/user-profile.service';
import { LOGINDETAILS } from 'src/app/component/system/accounts/model/login-audit';

@Component({
    selector: 'edit-help-text',
    templateUrl: './edit-help-text.component.html',
    styleUrl: './edit-help-text.component.scss'
})
export class EditHelpTextComponent implements OnInit {
    @Input() helpTextId!: string;
    @Input() helpText!: HelpText;

    form: FormGroup;
    user: LOGINDETAILS;

    editHelpText: HelpText;

    helpTextHeader: HelpTextHeader;
    helpTextBodies: HelpTextBody[] = [];
    helpTextFooter: HelpTextFooter;

    promises: any[] = [];
    isLoading: boolean = true;
    isSaving: boolean = false;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        public helpTextService: HelpTextService,
        public dialogRef: MatDialogRef<EditHelpTextComponent>,
        private userProfileService: UserProfileService
    ) {}

    ngOnInit(): void {
        this.isLoading = true;

        if (this.data) {
            this.helpTextId = this.data.helpTextId;
            this.helpText = this.data.helpText;
        }

        this.initForm();
        this.getUserProfile();

        Promise.all(this.promises).then((res) => {
            this.isLoading = false;
        });
    }

    getUserProfile() {
        let deferred = new Promise((resolve, reject) => {
            this.userProfileService.getMyProfile().subscribe((res) => {
                if (res?.user) {
                    this.user = res.user;

                    resolve(res);
                } else if (res?.msg) {
                    reject(res);
                } else {
                    reject('err');
                }
            });
        });
        this.promises.push(deferred);
    }

    initForm() {
        if (this.helpText && this.helpText.createdDate) {
            this.editHelpText = JSON.parse(JSON.stringify(this.helpText));

            if (this.data.routeUrl) {
                // Make sure routeUrls is an array, otherwise this could error out
                const currentRouteUrls = Array.isArray(this.helpText.routeUrls) ? this.helpText.routeUrls : [];
                this.editHelpText.routeUrls = [...currentRouteUrls, ...[this.data.routeUrl]];
            }
            this.editHelpText.routeUrls = [...new Set(this.editHelpText.routeUrls)];
        } else {
            this.editHelpText = new HelpText();
            this.editHelpText.id = this.helpTextId;
            this.editHelpText.header = new HelpTextHeader();
            this.editHelpText.footer = new HelpTextFooter();

            this.editHelpText.routeUrls = [];
            if (this.data.routeUrl) {
                this.editHelpText.routeUrls.push(this.data.routeUrl);
            }

            this.editHelpText.bodies = [];
            this.editHelpText.bodies.push(new HelpTextBody());
        }
    }

    addBody() {
      
        this.editHelpText.bodies?.push(new HelpTextBody());
          console.log("adding body:")
        console.log( this.editHelpText.bodies)
    }

    removeBody(index: number) {
        this.editHelpText.bodies?.splice(index, 1);
    }

    toggleListItem(body: HelpTextBody) {
        body.listItem = !body.listItem;
    }

    toggleBold(body: HelpTextBody) {
        body.bold = !body.bold;
    }

    submit() {
        if (this.checkValid()) {
            this.isSaving = true;
            this.promises = [];

            let payload = this.generatePayload();

            console.log("calling helpTextService.createUpdate() with ", payload)
            this.helpTextService.createUpdate(payload).subscribe((res) => {
                this.closeDialog(false, this.editHelpText);
                this.isSaving = false;
            });
        } else {
        }
    }

    checkValid() {
        if (
            this.editHelpText &&
            this.editHelpText.id &&
            ((this.editHelpText.header && this.editHelpText.header?.text) ||
                (this.editHelpText.bodies && this.editHelpText.bodies.length > 0 && this.editHelpText.bodies[0]?.text) ||
                (this.editHelpText.footer && this.editHelpText.footer?.text))
        ) {
            return true;
        } else {
            return false;
        }
    }

    generatePayload(): HelpText {
        let payload: HelpText = this.editHelpText;

        if (this.helpText.createdBy) {
            payload.modifiedBy = this.user.USER_ID;
        } else {
            payload.createdBy = this.user.USER_ID;
        }

        return payload;
    }

    closeDialog(refresh: boolean, helpText?: HelpText) {
        this.data = { refresh: refresh, helpText: helpText };
        this.dialogRef.close(this.data);
    }

    removeRouteUrl(routeUrl: string) {
        if (this.editHelpText.routeUrls) {
            const index = this.editHelpText.routeUrls?.findIndex((x) => x === routeUrl);
            if (index >= 0) {
                this.editHelpText.routeUrls?.splice(index, 1);
            }
        }
    }

    deleteHelpText() {
        this.isSaving = true;
        this.helpTextService.deleteHelpTexts(this.helpTextId).subscribe((res) => {
            this.closeDialog(true);
            this.isSaving = false;
        });
    }
}
